/* IceHab advisor pop-up logic (sections/icehab-wizard.liquid holds the markup, the texts and the product data in
   #ih-wz-data). No libraries, no outside services, no AI. Loaded with defer.
   Start (DJ 29 Oct 2026): the first two questions (where it will be used, people a day) show as a clean full-width
   WIZARD screen (class is-intro on the dialog). After the second answer it turns into the chat.
   Questions (DJ 29 Oct 2026): use > people > goal > where it stands (indoors / outdoors covered and shaded / outdoors
   not covered yet: never direct sun, never rain) > water changes > how you get in (skipped when UV XL + Ozone are
   both already in) > draining > floor (indoors only) > how you picture using it (always on 24/7) > spare filters > colour.
   Water add-ons: UV XL first (Ozone for extra duration); if UV XL is out of stock, Ozone takes its place. Businesses
   outdoors keep Ozone first. "Straight after training": filters only -> suggest UV XL; one of the two -> suggest the
   other. Every extra can be removed at the end.
   Type-a-question box in the answers card: simple keyword matching on the FAQ texts (+ their extra search words);
   no match -> a WhatsApp link with the question already filled in.
   A round WhatsApp button sits in the header next to the close button on every step. */
(function(){
  if (window.__ihWz) return; window.__ihWz = true;
  var dlg = document.getElementById('ih-wz'); if (!dlg) return;
  var D = JSON.parse(document.getElementById('ih-wz-data').textContent), P = D.p, T = D.t, F = D.faq || [];
  var msgs = dlg.querySelector('[data-wz-msgs]'), opts = dlg.querySelector('[data-wz-opts]');
  var pick = dlg.querySelector('[data-wz-pick]'), pickTxt = dlg.querySelector('[data-wz-picktxt]');
  var txf = dlg.querySelector('[data-wz-tx]'), txi = txf && txf.querySelector('input');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var H = [], st = {}, removed = {}, shown = {}, faqMode = false, busy = false, started = false, sentResult = false;
  var Q = {
    use: { q: T.q_use2, o: [['home', T.use_home2, T.use_home_s2], ['biz', T.use_biz2, T.use_biz_s2]] },
    ppl: { q: T.q_ppl2, o: [['2', '1–2'], ['8', '3–8'], ['20', '9–20'], ['21', '20+']] },
    goal: { q: T.q_goal, o: [['rec', T.goal_1], ['ene', T.goal_2], ['calm', T.goal_3], ['cur', T.goal_4]] },
    loc: { q: T.q_loc2, o: [['in', T.loc_in2, T.loc_in_s2], ['cov', T.loc_cov, T.loc_cov_s], ['open', T.loc_open, T.loc_open_s]] },
    water: { q: T.q_water, o: [['m', T.w_1, T.w_1s], ['mid', T.w_2, T.w_2s], ['rare', T.w_3, T.w_3s, T.w_tag]] },
    enter: { q: T.q_enter, o: [['clean', T.en_1], ['sweat', T.en_2]] },
    drain: { q: T.q_drain, o: [['near', T.dr_1], ['far', T.dr_2], ['ns', T.dr_3]] },
    floor: { q: T.q_floor, o: [['wood', T.fl_1], ['tile', T.fl_2], ['con', T.fl_3]] },
    mode: { q: T.q_mode, o: [['before', T.mo_1], ['always', T.mo_2]] },
    fil: { q: T.q_fil, o: [['yes', T.fil_1, T.fil_1s], ['no', T.fil_2, T.fil_2s]] },
    col: { q: T.q_col2, o: [['white', T.col_white], ['black', T.col_black]] }
  };
  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function cat(){ return Array.prototype.filter.call(arguments, Boolean).join(' '); }
  /* Wizard start screen (first two questions) */
  var chat = dlg.querySelector('.ih-wz__chat');
  var intro = el('div', 'ih-wz__intro');
  var iStep = el('span', 'ih-wz__istep'), iK = el('p', 'ih-wz__ik'), iQ = el('h3', 'ih-wz__iq'), iS = el('p', 'ih-wz__is');
  intro.appendChild(iStep); intro.appendChild(iK); intro.appendChild(iQ); intro.appendChild(iS);
  if (chat) chat.insertBefore(intro, msgs);
  function money(c){ var n = Math.round(c) / 100; return D.cur + n.toLocaleString('de-DE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function model(){ return (st.use === 'biz' || +st.ppl > 8) ? 'pro' : 'home'; }
  /* Add-ons: UV XL first, Ozone takes its place when UV XL is out of stock */
  function ok(k){ var p = P[k]; return !!(p && p.v && p.ok); }
  function other(k){ return k === 'uv' ? 'ozone' : 'uv'; }
  function first(a){ return ok(a) ? a : (ok(other(a)) ? other(a) : ''); }
  function waterAdds(){
    if (st.water === 'mid') { var f = first((st.use === 'biz' && st.loc && st.loc !== 'in') ? 'ozone' : 'uv'); return f ? [f] : []; }
    if (st.water === 'rare') return ['uv', 'ozone'].filter(ok);
    return [];
  }
  function enterAdd(){
    if (st.enter !== 'sweat') return '';
    var w = waterAdds(); if (!w.length) return first('uv');
    return (w.length === 1 && ok(other(w[0]))) ? other(w[0]) : '';
  }
  function addons(){ var a = waterAdds().slice(), e = enterAdd(); if (e && a.indexOf(e) < 0) a.push(e); return a; }
  function steps(){ var a = ['use', 'ppl', 'goal', 'loc', 'water']; if (waterAdds().length < 2) a.push('enter'); a.push('drain'); if (st.loc === 'in') a.push('floor'); a.push('mode', 'fil', 'col'); return a; }
  function nextStep(){ var a = steps(); for (var i = 0; i < a.length; i++) { if (!(a[i] in st)) return a[i]; } return 'result'; }
  function isIntro(n){ return !faqMode && (n === 'use' || n === 'ppl') && !H.some(function(h){ return h.t !== 'a'; }); }
  function qText(k){ var t = Q[k].q || ''; return k === 'fil' ? t.replace('[n]', model() === 'pro' ? '2 + 2' : '2') : t; }
  function label(k, v){ var o = Q[k].o; for (var i = 0; i < o.length; i++) { if (o[i][0] === v) return o[i][1]; } return v; }
  function reply(k, v){
    switch (k) {
      case 'use': return v === 'biz' ? T.r_biz : T.r_home;
      case 'ppl': return (model() === 'pro' ? T.r_m_pro : T.r_m_home) + (v === '21' && T.r_many2 ? ' ' + T.r_many2 : '');
      case 'goal': return T.r_goal;
      case 'loc': return cat(v === 'in' ? T.r_in3 : (v === 'open' ? T.r_open : T.r_cov), T.r_air);
      case 'water':
        if (v === 'm') return cat(T.r_w1, st.use === 'biz' ? T.r_w1_biz : '');
        if (v === 'mid') { var w = waterAdds()[0]; return w === 'uv' ? T.r_w2_uv : (w === 'ozone' ? T.r_w2_oz : T.r_w1); }
        return (T.r_w3 || '').replace('[n]', D.disc);
      case 'enter':
        if (v === 'clean') return T.r_en_clean;
        var e = enterAdd(); return cat(T.r_en_sweat, e === 'uv' ? T.r_en_uv : (e === 'ozone' ? T.r_en_oz : ''));
      case 'drain': return T.r_drain;
      case 'floor': return v === 'con' ? T.r_nomat : T.r_mat;
      case 'mode': return v === 'before' ? T.r_mode_before : T.r_mode_always;
      case 'fil': return v === 'yes' ? T.r_fil1 : T.r_fil2;
    }
    return '';
  }
  function items(){
    var out = []; if (!('ppl' in st)) return out;
    var m = model(), sys = P[m], blk = st.col === 'black';
    if (!sys || !sys.v) return out;
    out.push({ k: m, sys: true, id: blk ? sys.vb : sys.vw, t: sys.t + (st.col ? ' · ' + (blk ? T.col_black : T.col_white) : ''), img: (blk ? sys.ib : sys.iw) || sys.img, price: sys.price, why: m === 'pro' ? T.why_pro : T.why_home });
    function add(k, why){ var p = P[k]; if (p && p.v && p.ok) out.push({ k: k, id: p.v, t: p.t, img: p.img, price: p.price, why: why }); }
    addons().forEach(function(k){ add(k, k === 'uv' ? T.why_uv : T.why_oz); });
    if (st.loc === 'in' && st.floor && st.floor !== 'con') add('mat', T.why_mat);
    if (st.fil === 'yes') add(m === 'pro' ? 'f_pro' : 'f_home', T.why_fil);
    return out;
  }
  function active(){ return items().filter(function(i){ return i.sys || !removed[i.k]; }); }
  function totals(list){ var sum = 0, uv = 0, oz = 0; list.forEach(function(i){ sum += i.price; if (i.k === 'uv') uv = i.price; if (i.k === 'ozone') oz = i.price; }); var off = (uv && oz) ? Math.round((uv + oz) * D.disc / 100) : 0; return { sum: sum, off: off, total: sum - off }; }
  function bot(text, cls){ if (!text) return; msgs.appendChild(el('div', 'ih-wz__msg ih-wz__msg--bot' + (cls ? ' ' + cls : ''), text)); }
  function me(text){ msgs.appendChild(el('div', 'ih-wz__msg ih-wz__msg--me', text)); }
  function scroll(){ msgs.scrollTo({ top: msgs.scrollHeight, behavior: reduce ? 'auto' : 'smooth' }); }
  function waLink(q){ var b = T.r_help_link || ''; if (!b) return ''; return q ? b + (b.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(q) : b; }
  /* Type-a-question: keyword matching on the FAQ (question + extra words count double, answer counts once) */
  var STOP = ' the and or of to in on at for with is are am be do does did im my me you your it its this that can could will would should need how what when where which who why there their our we if about any get got have has much many from not but so than then just also very please hi hello ';
  function words(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').split(/[^a-z0-9]+/).filter(function(w){ return w.length > 1 && STOP.indexOf(' ' + w + ' ') < 0; }).map(function(w){ return w.slice(0, 4); }); }
  function hit(s, list){ for (var i = 0; i < list.length; i++) { var w = list[i]; if (w === s || (w.length > 2 && s.length > 2 && (w.indexOf(s) === 0 || s.indexOf(w) === 0))) return true; } return false; }
  function match(q){
    var qs = []; words(q).forEach(function(w){ if (qs.indexOf(w) < 0) qs.push(w); });
    var best = -1, bs = 0;
    F.forEach(function(f, i){
      var hi = words(f.q + ' ' + (f.k || '')), lo = words(f.a), sc = 0;
      qs.forEach(function(s){ if (hit(s, hi)) sc += 2; else if (hit(s, lo)) sc += 1; });
      if (sc > bs) { bs = sc; best = i; }
    });
    return bs >= 2 ? best : -1;
  }
  /* WhatsApp button in the header, always visible */
  (function(){
    if (!T.r_help_link) return;
    var head = dlg.querySelector('.ih-wz__head'), x = dlg.querySelector('[data-wz-close]'); if (!head || !x) return;
    var wa = el('a', 'ih-wz__wa'); wa.href = T.r_help_link; wa.target = '_blank'; wa.rel = 'noopener';
    wa.setAttribute('aria-label', T.r_help || 'WhatsApp'); wa.title = T.r_help || '';
    wa.style.cssText = 'flex:none;display:grid;place-items:center;width:38px;height:38px;border-radius:50%;background:rgba(37,211,102,.14);color:#1DA851;text-decoration:none;';
    wa.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.6-.3z"/></svg>';
    wa.addEventListener('click', function(){ publish('icehab_wizard_whatsapp', { step: nextStep() }); });
    head.insertBefore(wa, x);
  })();
  function render(fresh){
    st = {}; H.forEach(function(h){ if (h.t === 'a') st[h.s] = h.v; });
    msgs.innerHTML = '';
    bot(T.hello);
    var cut = -1, lastMe = -1;
    H.forEach(function(h, i){
      var last = fresh && i === H.length - 1;
      if (h.t === 'f' || h.t === 'x') {
        me(h.t === 'f' ? F[h.i].q : h.q);
        if (last) { lastMe = msgs.children.length - 1; cut = msgs.children.length; }
        if (h.i > -1 && F[h.i]) { bot(F[h.i].a); return; }
        bot(T.tx_none);
        var wl = waLink(h.q);
        if (wl) { var a = el('a', 'ih-wz__msg ih-wz__msg--bot ih-wz__msg--link ih-wz__msg--wa', (T.tx_wa || T.r_help || 'WhatsApp') + ' →'); a.href = wl; a.target = '_blank'; a.rel = 'noopener'; msgs.appendChild(a); }
        return;
      }
      bot(qText(h.s)); me(label(h.s, h.v));
      if (last) { lastMe = msgs.children.length - 1; cut = msgs.children.length; }
      bot(reply(h.s, h.v));
      if (h.s === 'water') bot(T.w_note, 'ih-wz__msg--note');
    });
    var n = nextStep();
    bot(n === 'result' ? T.r_done : qText(n), 'ih-wz__msg--q');
    if (n === 'result' && T.guide_text && T.guide_link) {
      var g = el('a', 'ih-wz__msg ih-wz__msg--bot ih-wz__msg--link', T.guide_text + ' →'); g.href = T.guide_link; msgs.appendChild(g);
    }
    if (lastMe > -1) msgs.children[lastMe].classList.add('is-new');
    if (cut > -1) { for (var j = cut; j < msgs.children.length; j++) msgs.children[j].classList.add('is-wait', 'is-new'); }
    options(n); panel(n);
    var im = isIntro(n);
    dlg.classList.toggle('is-intro', im);
    if (im) {
      var step = n === 'use' ? 1 : 2;
      iStep.textContent = (T.intro_step || '[n] / 2').replace('[n]', step);
      iK.textContent = T.intro_title || '';
      iQ.textContent = qText(n);
      iS.textContent = step === 1 ? (T.intro_sub || '') : reply('use', st.use);
      iK.hidden = !iK.textContent; iS.hidden = !iS.textContent;
      intro.classList.remove('is-new'); void intro.offsetWidth; if (!reduce) intro.classList.add('is-new');
    }
    var a2 = steps(), done = a2.filter(function(k){ return k in st; }).length;
    dlg.querySelector('[data-wz-bar]').style.width = (n === 'result' ? 100 : Math.max(4, Math.round(done / a2.length * 100))) + '%';
    dlg.querySelector('[data-wz-back]').hidden = !H.length;
    dlg.querySelector('[data-wz-ask]').hidden = !F.length || faqMode || im;
    dlg.classList.toggle('is-fresh', !H.length);
    if (n === 'result' && fresh) {
      if (window.matchMedia('(max-width: 749px)').matches) setPanel(true);
      if (!sentResult) { sentResult = true; publish('icehab_wizard_result', { model: model(), answers: st, total: totals(active()).total / 100 }); }
    }
  }
  function options(n){
    opts.innerHTML = ''; opts.className = 'ih-wz__opts';
    pick.hidden = n === 'result' && !faqMode;
    pickTxt.textContent = faqMode ? (T.pick_faq || '') : (T.pick || '');
    if (faqMode) {
      opts.classList.add('ih-wz__opts--faq');
      F.forEach(function(f, i){ var b = el('button', 'ih-wz__chip', f.q); b.type = 'button'; b.setAttribute('data-faq', i); opts.appendChild(b); });
      var bk = el('button', 'ih-wz__chip ih-wz__chip--back', T.ask_back); bk.type = 'button'; bk.setAttribute('data-wz-askback', ''); opts.appendChild(bk);
      return;
    }
    if (n === 'result') {
      opts.classList.add('ih-wz__opts--end');
      var r = el('button', 'ih-wz__chip', T.restart); r.type = 'button'; r.setAttribute('data-wz-restart', ''); opts.appendChild(r);
      if (T.r_help && T.r_help_link) { var w = el('a', 'ih-wz__chip ih-wz__chip--wa', T.r_help); w.href = T.r_help_link; w.target = '_blank'; w.rel = 'noopener'; opts.appendChild(w); }
      return;
    }
    var o = Q[n].o; opts.classList.add('ih-wz__opts--n' + o.length);
    if (o.some(function(x){ return x[2]; })) opts.classList.add('ih-wz__opts--rich');
    o.forEach(function(x){
      var b = el('button', 'ih-wz__opt'); b.type = 'button'; b.setAttribute('data-v', x[0]);
      var t = el('b', null, x[1]); if (x[3]) t.appendChild(el('i', 'ih-wz__tag', x[3])); b.appendChild(t);
      if (x[2]) b.appendChild(el('small', null, x[2]));
      opts.appendChild(b);
    });
  }
  function panel(n){
    var all = items(), done = n === 'result', ul = dlg.querySelector('[data-wz-list]'), now = {};
    ul.innerHTML = '';
    all.forEach(function(i){
      var off = !i.sys && removed[i.k], key = i.k + '|' + i.t;
      now[key] = true;
      var li = el('li', (off ? 'is-off' : '') + (shown[key] ? '' : ' is-new'));
      var im = el('img'); im.alt = ''; im.loading = 'lazy'; if (i.img) im.src = i.img; li.appendChild(im);
      var tx = el('span', 'ih-wz__it'); tx.appendChild(el('b', null, i.t)); if (i.why) tx.appendChild(el('small', null, i.why));
      if (done && !i.sys) { var rb = el('button', 'ih-wz__rm', off ? T.rm_undo : T.rm); rb.type = 'button'; rb.setAttribute('data-wz-rm', i.k); tx.appendChild(rb); }
      li.appendChild(tx); li.appendChild(el('em', null, money(i.price))); ul.appendChild(li);
    });
    shown = now;
    var list = active(), t = totals(list);
    if (t.off) { var d = el('li', 'is-disc'); d.appendChild(el('i')); d.appendChild(el('span', 'ih-wz__it', (T.r_set2 || '').replace('[n]', D.disc))); d.appendChild(el('em', null, '−' + money(t.off))); ul.appendChild(d); }
    var has = all.length > 0;
    dlg.querySelector('[data-wz-pempty]').hidden = has;
    dlg.querySelector('[data-wz-sum]').hidden = !has;
    dlg.querySelector('[data-wz-note]').hidden = !has;
    dlg.querySelector('[data-wz-total]').textContent = money(t.total);
    dlg.querySelector('[data-wz-ptotal]').textContent = has ? money(t.total) : '';
    var cnt = list.length === 1 ? (T.p_count1 || T.p_count || '[n]') : (T.p_count || '[n]');
    dlg.querySelector('[data-wz-pcount]').textContent = has ? '· ' + cnt.replace('[n]', list.length) : '';
    dlg.querySelector('[data-wz-add]').disabled = !done;
    dlg.querySelector('[data-wz-phint]').hidden = done;
    dlg.classList.toggle('is-done', done);
  }
  function setPanel(on){ dlg.classList.toggle('is-panel', on); dlg.querySelector('[data-wz-ptoggle]').setAttribute('aria-expanded', on ? 'true' : 'false'); }
  function go(fresh){
    render(fresh);
    var w = msgs.querySelectorAll('.is-wait');
    if (dlg.classList.contains('is-intro')) { w.forEach(function(x){ x.classList.remove('is-wait'); }); return; }
    if (fresh && w.length && !reduce) {
      busy = true; dlg.classList.add('is-busy');
      var ty = el('div', 'ih-wz__msg ih-wz__msg--bot ih-wz__typing is-new'); ty.innerHTML = '<i></i><i></i><i></i>'; msgs.appendChild(ty); scroll();
      setTimeout(function(){ ty.remove(); w.forEach(function(x){ x.classList.remove('is-wait'); }); busy = false; dlg.classList.remove('is-busy'); scroll(); }, 700);
    } else { w.forEach(function(x){ x.classList.remove('is-wait'); }); msgs.scrollTop = msgs.scrollHeight; }
  }
  function publish(name, data){ try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }
  function open(){ if (!started) { started = true; go(false); } if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', ''); document.documentElement.classList.add('ih-wz-lock'); setTimeout(function(){ msgs.scrollTop = msgs.scrollHeight; }, 30); }
  function close(){ if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } } document.documentElement.classList.remove('ih-wz-lock'); }
  window.ihWizardOpen = open;
  dlg.addEventListener('close', function(){ document.documentElement.classList.remove('ih-wz-lock'); });
  if (txf) txf.addEventListener('submit', function(e){
    e.preventDefault(); if (busy) return;
    var q = (txi.value || '').trim(); if (!q) return;
    var i = match(q); txi.value = ''; txi.blur();
    faqMode = false; H.push({ t: 'x', q: q.slice(0, 300), i: i });
    publish('icehab_wizard_question', { question: q.slice(0, 300), answered: i > -1 });
    go(true);
  });
  dlg.addEventListener('click', function(e){
    if (e.target === dlg) { close(); return; }
    if (e.target.closest('[data-wz-close]')) { close(); return; }
    if (e.target.closest('[data-wz-ptoggle]')) { setPanel(!dlg.classList.contains('is-panel')); return; }
    var ad = e.target.closest('[data-wz-add]'); if (ad) { addAll(ad); return; }
    var rm = e.target.closest('[data-wz-rm]'); if (rm) { var k = rm.getAttribute('data-wz-rm'); removed[k] = !removed[k]; panel(nextStep()); return; }
    if (busy) return;
    var b = e.target.closest('[data-v]');
    if (b) { var n = nextStep(); if (n === 'result') return; H.push({ t: 'a', s: n, v: b.getAttribute('data-v') }); removed = {}; go(true); return; }
    var fq = e.target.closest('[data-faq]');
    if (fq) { faqMode = false; H.push({ t: 'f', i: +fq.getAttribute('data-faq') }); go(true); return; }
    if (e.target.closest('[data-wz-ask]')) { faqMode = true; options(nextStep()); dlg.querySelector('[data-wz-ask]').hidden = true; return; }
    if (e.target.closest('[data-wz-askback]')) { faqMode = false; options(nextStep()); dlg.querySelector('[data-wz-ask]').hidden = !F.length; return; }
    if (e.target.closest('[data-wz-back]')) { H.pop(); removed = {}; faqMode = false; go(false); if (nextStep() !== 'result') setPanel(false); return; }
    if (e.target.closest('[data-wz-restart]')) { H = []; removed = {}; faqMode = false; sentResult = false; setPanel(false); go(false); return; }
  });
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-ih-wizard], a[href$="#help-me-choose"]');
    if (!t) return; e.preventDefault(); open();
  });
  if (location.hash === '#help-me-choose') setTimeout(open, 300);
  if (D.auto) { try { if (!localStorage.getItem('ihWzSeen')) { setTimeout(function(){ if (!document.querySelector('dialog[open]')) { open(); try { localStorage.setItem('ihWzSeen', '1'); } catch (e) {} } }, D.delay * 1000); } } catch (e) {} }
  async function addAll(btn){
    if (btn.disabled) return;
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var list = active().sort(function(a, b){ return a.price - b.price; });
    var its = list.map(function(i){ return { id: Number(i.id), quantity: 1 }; });
    btn.disabled = true;
    publish('icehab_wizard_add_to_cart', { model: model(), items: list.map(function(i){ return i.k; }), total: totals(list).total / 100 });
    var drawer = document.querySelector('theme-drawer#cart-drawer'), Ev = null;
    try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (x) { Ev = null; }
    try {
      if (!Ev || !drawer) {
        var r0 = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: its }) });
        if (!r0.ok) throw new Error(T.r_error);
        location.href = ROOT + 'cart'; return;
      }
      var secIds = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component')).map(function(c){ return c.dataset.sectionId; }).filter(Boolean)));
      var deferred = Ev.createPromise();
      document.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: its.map(function(i){ return { merchandiseId: i.id, quantity: i.quantity }; }), promise: deferred.promise }));
      var r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: its, sections: secIds.join(',') }) });
      var res = await r.json();
      if (!r.ok) { deferred.reject(new Error(res.description || T.r_error)); throw new Error(res.description || T.r_error); }
      var cart = await fetch(ROOT + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function(x){ return x.json(); });
      deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'icehab-wizard', sourceId: 'icehab-wizard', itemCount: its.length, sections: res.sections, didError: false } });
      btn.classList.add('is-ok');
      setTimeout(function(){ close(); btn.classList.remove('is-ok'); btn.disabled = false; if (typeof drawer.open === 'function') drawer.open(); }, 600);
    } catch (err) { btn.disabled = false; alert(err.message || T.r_error); }
  }
})();
